<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-header-title">
          {{ $t('invoices') }}
        </h4>
        <router-link
          class="btn btn-sm btn-primary"
          :to="'/invoices/create?customer_id=' + $route.params.id"
          v-if="$parent.item.stat == 1 && $checkRole('invoices_add')"
        >
          <i class="fas fa-plus"></i>
          {{ $t('Addition') }}
        </router-link>
      </div>
      <indexTable
        :searchText="$parent.$t('Search for an invoice')"
        :withoutCard="true"
        :emptyTableText="$parent.$t('There are no bills')"
        :filter="{ customer_id: $route.params.id }"
        :emptyTableSubText="$parent.$t('Try adding some items to the table and try again')"
        :statusSearch="true"
        :statusValues="[
          {
            title: $parent.$t('Situation'),
            value: ''
          },
          {
            title: $parent.$t('All'),
            value: ''
          },
          { title: $parent.$t('draft'), value: 0 },
          { title: $parent.$t('Sent'), value: 1 },
          { title: $parent.$t('Seen'), value: 2 },
          {
            title: $parent.$t('Driven'),
            value: 3
          },
          {
            title: $parent.$t('Canceled'),
            value: 4
          }
        ]"
        :cloumns="[
          {
            column: 'code',
            title: $parent.$t('invoice'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'date',
            title: $parent.$t('The date of the invoice'),
            type: 'text',
            sort: true
          },
          {
            column: 'client_type',
            title: $parent.$t('Customer name'),
            type: 'clintLink',
            sort: false
          },
          {
            column: 'total',
            title: $parent.$t('Cost'),
            type: 'text',
            sort: true
          },
          {
            column: 'rest',
            title: $parent.$t('Balance'),
            type: 'text',
            sort: true
          },
          {
            column: 'status',
            title: $parent.$t('Situation'),
            type: 'status',
            sort: true,
            values: [
              {
                title: $parent.$t('draft'),
                value: 0,
                color: 'dark'
              },
              {
                title: $parent.$t('Sent'),
                value: 1,
                color: 'primary'
              },
              {
                title: $parent.$t('Seen'),
                value: 2,
                color: 'primary'
              },
              {
                title: $parent.$t('Driven'),
                value: 3,
                color: 'success'
              },
              {
                title: $parent.$t('Canceled'),
                value: 4,
                color: 'danger'
              }
            ]
          },
          {
            column: 'options',
            title: $parent.$t('Settings'),
            type: 'options',
            options: [
              { name: 'show' },
              {
                name: 'edit',
                role: $checkRole('invoices_edit')
              },
              { name: 'outLink', role: true },
              { name: 'printInvoice', role: true },
              { name: 'download', role: true },
              {
                name: 'delete',
                role: $checkRole('invoices_delete')
              }
            ]
          }
        ]"
        :deleteText="{
          attention: $parent.$t('Attention'),
          areYouReallySureToDeleteTheItem: $parent.$t('Are you really sure to delete the item'),
          close: $parent.$t('Close'),
          confirm: $parent.$t('Confirm'),
          loading: $parent.$t('Loading')
        }"
      />
    </div>
  </div>
</template>
<script>
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/invoices',

      customer_id: this.$route.params.id,
      status: this.$route.params.status ? this.$route.params.status : ''
    }
  },
  components: {
    indexTable
  }
}
</script>
